/**
 * BuyboxCreatePage - Form for investors to create new buyboxes.
 *
 * Thin wrapper around BuyboxForm that handles navigation.
 */

import { useNavigate } from '@tanstack/react-router'

import { useMarkets } from '@/common/hooks/useMarkets'
import { BuyboxForm } from '@/features/buyboxes/components/BuyboxForm'

export const Route = createFileRoute({
  component: BuyboxCreatePage,
})

function BuyboxCreatePage() {
  const navigate = useNavigate()
  const { investorMarketOptions } = useMarkets({ includeUpcoming: true })

  const handleSuccess = () => {
    navigate({ to: '/buybox' })
  }

  const handleCancel = () => {
    navigate({ to: '/buybox' })
  }

  return (
    <BuyboxForm
      mode="create"
      marketOptions={investorMarketOptions}
      onSuccess={handleSuccess}
      onCancel={handleCancel}
    />
  )
}
